import React from 'react';
import type { Cost } from '../costs/costs';
import type { Income } from '../income/income';
import { Box, Badge, Text, Tooltip } from '../../ui';

export const ParamIndicator = ({
  param,
  tooltipText,
}: {
  param:
    | Extract<Cost, { type: 'BUNKER' | 'INVOICE_FREIGHT' }>['params'][number]
    | Income['params'][number];
  tooltipText?: string;
}) => {
  const valueContent = (
    <Text fontSize={1}>
      {param.value !== null
        ? typeof param.value === 'number'
          ? Number.isInteger(param.value)
            ? param.value
            : param.value.toFixed(2)
          : param.value
        : 'N/A'}
    </Text>
  );
  return (
    <Box
      title={'source' in param ? `Source: ${param.source}` : ''}
      key={param.name}
      display="inline-flex"
      mr={2}
      data-testid={param.testId}
    >
      <Badge>
        <Text fontSize={1} mr={2} fontWeight="normal">
          {param.name}:
        </Text>
        {!tooltipText && valueContent}
        {tooltipText && (
          <Tooltip content={<Text>{tooltipText}</Text>}>{valueContent}</Tooltip>
        )}
      </Badge>
    </Box>
  );
};
